import React, { ReactElement, memo } from "react";

// constants
import { TEXTS } from "@cart-ui/constants";

// helpers
import { AriaHidden, useEffectOnce } from "@swiggy-private/core-ui";

// test ids
import { CART_FOOTER_TEST_IDS } from "@swiggy-private/cart-test-ids";

// styled components
import { Container, ContainerMeta, MetaTextWrapper, ActionsSection, ActionButton } from "../styled";

//dls components
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";
import { default as LocationFilledIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/locationFilled/20";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

//types and interfaces
export interface AddSelectAddressProps {
    onCtaClick: VoidFunction;
    onImpression: VoidFunction;
    isJioHotstarFlow?: boolean;
}

function AddSelectAddress(props: AddSelectAddressProps): ReactElement {
    const { onCtaClick, onImpression, isJioHotstarFlow } = props;
    useEffectOnce(() => {
        onImpression();
    });

    return (
        <Container>
            <ContainerMeta>
                <AriaHidden as="div">
                    <GenericIcon Icon={LocationFilledIcon} fillColor="primary" strokeColor="primary" />
                </AriaHidden>
                <MetaTextWrapper>
                    <Text variant="V2.subheading1.neutral.black" color="text_High_Emphasis">
                        {isJioHotstarFlow ? TEXTS.WHERE_TO_DELIVER_JHS : TEXTS.WHERE_TO_DELIVER}
                    </Text>
                </MetaTextWrapper>
            </ContainerMeta>
            <ActionsSection>
                <ActionButton
                    onClick={onCtaClick}
                    data-testid={CART_FOOTER_TEST_IDS.ADD_ADDRESS_TO_PROCEED_BTN}
                    variant="fullwidth"
                    buttonType="primary"
                    buttonSize="large"
                >
                    {TEXTS.ADD_OR_SELECT_ADDRESS}
                </ActionButton>
            </ActionsSection>
        </Container>
    );
}

export default memo(AddSelectAddress);
